module.exports = __webpack_public_path__ + "static/media/59330249_609337592886194_7787880660999340032_o.2e04200b.jpg";